import '~/assets/js/51la.js'

export default defineNuxtPlugin(() => {});
